import { ReactNode, useEffect, useState } from "react";
import { Icon } from "./icon/Icon";

interface ModalProps {
  title: string;
  onClose: () => void;
  children?: ReactNode;
}

const Modal = ({ title, onClose, children }: ModalProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timeout);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 200);
  };
  return (
    <>
      <button
        onClick={handleClose}
        className={`fixed w-full h-full left-0 top-0 z-30 bg-white/10 backdrop-blur-xs transition-opacity duration-200 ${
          visible ? "opacity-100" : "opacity-0"
        }`}
      ></button>

      <div
        className={`fixed w-full max-h-[90%] overflow-scroll left-0 bottom-0 z-40 bg-bg rounded-t-2xl transform transition-transform duration-200 ${
          visible ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ paddingBottom: "var(--tg-safe-area-inset-bottom)" }}
      >
        <div className="flex items-center justify-between p-4 gap-1.5">
          <div className="shrink-0 w-7"></div>
          <p className="text-[1.0625rem] leading-[1.375rem] font-semibold text-text">
            {title}
          </p>
          <button
            onClick={handleClose}
            className="shrink-0 p-2 bg-plain-background rounded-full"
          >
            <Icon type="x" className="fill-plain-foreground/50 w-3 h-3" />
          </button>
        </div>

        <div className="w-full flex flex-col">{children}</div>
      </div>
    </>
  );
};

export default Modal;
